import { InstanceScreen } from 'component/navigation/instance';
import { useLocalSearchParams } from 'expo-router';

export default function SpaceRecordingVoteScreen() {
    const { csrfToken1, sliderValue1, voteKey1, voteLabel1 } = useLocalSearchParams<'/[siloKey]/question/[instanceKey]/recordingVote'>();
    return <InstanceScreen params={{ csrfToken1, sliderValue1, voteKey1, voteLabel1 }} screenKey='recordingVote' />;
}
